<template>
<div class="video-con">
  <video class="video" width="100%" height="100%" :src="videoSrc" controls autoplay></video>
</div>
</template>

<script>
export default {
  data(){
    return{
      videoSrc: this.session('videoSrc') || 'http://qiniufile.xdaocloud.com/mall/tips/about.mp4',
    }
  },
  created(){

  },
  methods: {

  }
}
</script>

<style lang="less" scoped>
.video-con{
  position: relative;z-index: 1;
  width: 100%;height: 100%;
  background-color: #000;
  .video{
    display: block;
    min-width: 100%;
    max-width: 100%;
    max-height: 100%;
  }
}
</style>